<template>
  <div class="main-app">
    <div class="website" v-if="!$route.fullPath.includes('epay')">
      <header v-if="!$route.fullPath.includes('cam') && !$route.fullPath.includes('see')">
        <nav class="navbar navbar-expand-lg navbar-light bg-nav fixed-top" id="navbar">
          <div class="container">
            <!-- just show in mobile -->
            <div class="stay-left d-flex align-items-center">
              <router-link @dragstart.prevent to="/" class="navbar-brand"><img src="./assets/logo.png"
                  alt="فروشگاه نوراشاپ" class="logo"></router-link><span v-if="$isAuthenticated">{{ $User.wallet.toLocaleString('fa') }}
                <ToomanSvg />
              </span>
            </div>
            <!-- just show in desktop -->
            <div class="stayl-right">
              <button class="mobile-menu-btn navbar-toggler" type="button" data-bs-toggle="offcanvas"
                data-bs-target="#OffcanvasMenu" aria-controls="OffcanvasMenu" aria-label="منو">
                <i class="fa fa-bars mobile-menu-icon" aria-hidden="true"></i>
              </button>
              <div class="collapse navbar-collapse dir-rtl">
                <div class="navbar-nav">
                  <router-link class="nav-link nav-link-icon" to="/epay" v-if="$User.isStaff">
                    <lord-icon class="nav-lord-icon" src="/img/icons/uymmojcb.json" stroke="bold"
                      colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                    </lord-icon>
                  </router-link>
                  <p class="nav-link pointer nav-link-icon" @click="logout()" v-if="$isAuthenticated">
                    <lord-icon class="nav-lord-icon" src="/img/icons/tildxrxd.json" stroke="bold"
                      colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                    </lord-icon>
                  </p>
                  <router-link aria-label="حساب کاربری" to="/account" class="nav-link pointer nav-link-icon"
                    v-if="$isAuthenticated">
                    <lord-icon class="nav-lord-icon" src="/img/icons/zzlwwnyo.json" state="hover-looking-around"
                      stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                    </lord-icon>
                  </router-link>
                  <a class="nav-link pointer nav-link-icon" v-if="!$isAuthenticated" data-bs-toggle="modal"
                    data-bs-target="#login-modal">
                    <lord-icon class="nav-lord-icon" src="/img/icons/zzlwwnyo.json" state="hover-looking-around"
                      stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                    </lord-icon>
                  </a>
                  <p class="nav-link pointer nav-link-icon" data-bs-toggle="offcanvas" data-bs-target="#wish"
                    aria-controls="wish">
                    <lord-icon class="nav-lord-icon" src="/img/icons/tacaigvj.json" state="hover-looking-around"
                      stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                    </lord-icon>
                    <span class="cart-count fw-bold px-1">{{ Object.keys(wish).length }}</span>
                  </p>
                  <p class="nav-link pointer nav-link-icon" data-bs-toggle="offcanvas" data-bs-target="#cart"
                    aria-controls="cart">
                    <lord-icon class="nav-lord-icon" src="/img/icons/fgvnxnhj.json" state="hover-looking-around"
                      stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                    </lord-icon>
                    <span class="cart-count fw-bold px-1">{{ Object.keys(cart).length }}</span>
                  </p>
                  <a class="nav-link pointer nav-link-icon" @click="search()">
                    <lord-icon class="nav-lord-icon" src="/img/icons/onakdvdu.json" state="hover-looking-around"
                      stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                    </lord-icon>
                  </a>
                </div>
                <span class="pipe">|</span>
                <div class="navbar-nav">
                  <router-link class="nav-link" to="/">نوراشاپ</router-link>
                  <router-link @mouseover="showMega = true" @mouseleave="showMega = false" class="nav-link"
                    to="/category-list">فروشگاه <i class="fa fa-angle-double-down"></i></router-link>
                  <router-link @mouseover="showMegaBrands = true" @mouseleave="showMegaBrands = false"
                    class="nav-link" to="/brands">برندها <i class="fa fa-angle-double-down"></i></router-link>
                  <div class="dropdown dropdown2">
                    <router-link class="nav-link" to="/blogs">مطالب <i class="fa fa-angle-down"></i></router-link>
                    <div class="dropdown-content p-4 content2">
                      <router-link :to="'/blogs/' + category.slug" :key="(category, index)"
                        v-for="(category, index)  in $blogCategories">{{ category.name }}</router-link>
                    </div>
                  </div>
                  <router-link class="nav-link" to="/events">خرید کادو</router-link>
                  <router-link class="nav-link" to="/about">درباره‌ما</router-link>
                  <router-link class="nav-link" to="/contact">ارتباط‌با‌ما</router-link>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <!-- mega menu -->
        <div class="dropdown-content c-megamenu p-4 text-end" :class="showMega ? 'show-me' : 'hide-me'"
          @mouseover="showMega = true" @mouseleave="showMega = false">
          <template :key="(category,index)" v-for="(category, index) in $categories">
            <div class="col-auto min-w-mega-menu2">
              <router-link class="category-megamenu" :to="'/category/' + category.slug">{{ category.name
                }}</router-link>
              <router-link class="subcategory-megamenu" :to="'/sub-category/' + category.slug + '/' + subcategory.slug"
                :key="(subcategory, index)" v-for="(subcategory, index)  in category.subcategories">{{ subcategory.name
                }}</router-link>
            </div>
            <div class="vr"></div>
          </template>
          <div class="blogs-list">
            <div class="col-auto min-w-mega-menu">
              <div v-if="$newBlog.length != 0">
                <router-link class="category-megamenu" to="/blogs/">جدیدترین مطالب</router-link>
                <router-link @dragstart.prevent
                  :to="'/blog/' + this.$blogCategories.filter(item => item.id === $newBlog[0].category)[0].slug + '/' + $newBlog[0].slug">
                  <img v-lazy="$RESIZE + $newBlog[0].image + '&blog=1'" class="ms-3 my-2" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- mega menu brands -->
        <div class="dropdown-content c-megamenu p-4 text-end" :class="showMegaBrands ? 'show-me' : 'hide-me'"
          @mouseover="showMegaBrands = true" @mouseleave="showMegaBrands = false">
          <template :key="(category,index)" v-for="(category, index) in $categories">
            <div class="vr2" v-if="index > 0"></div>
            <div class="col-auto min-w-mega-menu">
              <router-link class="category-megamenu" :to="'/category/' + category.slug">{{ category.name
                }}</router-link>
              <router-link class="subcategory-megamenu" :to="'/brand/' + brand.slug" :key="(brand, index)"
                v-for="(brand, index)  in category.brands">{{ brand.name }}</router-link>
            </div>
          </template>
        </div>
        <!-- nav drawer -->
        <div class="offcanvas offcanvas-end" data-bs-scroll="true" tabindex="-1" id="OffcanvasMenu"
          aria-labelledby="offcanvasExampleLabel">
          <div class="offcanvas-header">
            <router-link to="/">
              <h5 class="offcanvas-title" data-bs-dismiss="offcanvas" id="offcanvasExampleLabel">نوراشاپ</h5>
            </router-link>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="بستن"></button>
          </div>
          <div class="offcanvas-body">
            <div class="navbar-nav dir-rtl lh-offcanvas">
              <router-link class="nav-link color-black" data-bs-dismiss="offcanvas" to="/"><i class="fa fa-home"
                  aria-hidden="true"></i> نوراشاپ</router-link>
              <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingOne">
                    <a class="accordion-button collapsed nav-link color-black m-0 fw-normal px-2 w-100 rounded-3"
                      type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false"
                      aria-controls="flush-collapseOne">
                      <i class="fa fa-shopping-bag ms-1" aria-hidden="true"></i> فروشگاه
                    </a>
                  </h2>
                  <div id="flush-collapseOne" class="accordion-collapse collapse shadow-lg"
                    aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                    <div class="accordion-body rounded-bottom">
                      <data :key="(category, index)" v-for="(category, index) in $categories">
                        <router-link data-bs-dismiss="offcanvas" class="nav-link color-black"
                          :to="'/category/' + category.slug">{{ category.name }}</router-link>
                      </data>
                    </div>
                  </div>
                </div>
              </div>
              <router-link class="nav-link color-black" data-bs-dismiss="offcanvas" to="/blogs"><i class="fa fa-blog"
                  aria-hidden="true"></i> مطالب</router-link>
              <router-link class="nav-link color-black" data-bs-dismiss="offcanvas" to="/brands"><i class="fa fa-tag"
                  aria-hidden="true"></i> برندها</router-link>
              <router-link class="nav-link color-black" data-bs-dismiss="offcanvas" to="/events"><i class="fa fa-gift"
                  aria-hidden="true"></i> خرید کادو</router-link>
              <router-link class="nav-link color-black" data-bs-dismiss="offcanvas" to="/about"><i
                  class="fa fa-info-circle" aria-hidden="true"></i> درباره‌ما</router-link>
              <router-link class="nav-link color-black" data-bs-dismiss="offcanvas" to="/contact"><i class="fa fa-phone"
                  aria-hidden="true"></i> ارتباط‌با‌ما</router-link>
              <p class="nav-link color-black pointer" @click="logout()" v-if="$isAuthenticated"
                data-bs-dismiss="offcanvas"><i class="fa fa-sign-out" aria-hidden="true"></i> خروج از حساب کاربری</p>
            </div>
          </div>
          <footer class="footer">
            <div class="container">
              <p class="footer-text-menu text-left py-2 m-0">
                <span>© 2022 Nuora from </span>
                <a href="https://tmayt.ir">TMAYT</a>
                <span class="mx-2">|</span>
                <router-link to="/terms"> قوانین سایت</router-link>
              </p>
            </div>
          </footer>
        </div>
      </header>
      <div id="page-content" class="page-content">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
        <a v-if="!$route.fullPath.includes('cam')" class="btn btn-outline-success" id="msgBtn" data-bs-toggle="modal"
          data-bs-target="#msg-modal"><i class="fa fa-phone gototop-icon" aria-hidden="true"></i></a>
      </div>
      <!-- mobile bottom menu -->
      <div class="bottom-menu d-lg-none" v-if="!$route.fullPath.includes('cam')">
        <div>
          <div class="d-flex justify-content-between bg-nav shadow">
            <div class="stay-left-m p-2">
              <router-link to="/account" class="p-2 px-3 pointer" v-if="$isAuthenticated">
                <lord-icon class="nav-lord-icon" src="/img/icons/zzlwwnyo.json" state="hover-looking-around"
                  stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                </lord-icon>

              </router-link>
              <a class="p-2 px-3 pointer" v-if="!$isAuthenticated" data-bs-toggle="modal"
                data-bs-target="#login-modal">
                <lord-icon class="nav-lord-icon" src="/img/icons/zzlwwnyo.json" state="hover-looking-around"
                  stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                </lord-icon>
              </a>
              <a class="p-2 px-3 pointer" data-bs-toggle="offcanvas" data-bs-target="#wish" aria-controls="wish"><span
                  class="cart-count fw-bold px-1">{{ Object.keys(wish).length }}</span>
                <lord-icon class="nav-lord-icon" src="/img/icons/tacaigvj.json" state="hover-looking-around"
                  stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                </lord-icon>
              </a>
            </div>
            <div class="stay-right-m p-2">
              <a class="p-2 px-3 pointer" data-bs-toggle="offcanvas" data-bs-target="#cart" aria-controls="cart"><span
                  class="cart-count fw-bold px-1">{{ Object.keys(cart).length }}</span>
                <lord-icon class="nav-lord-icon" src="/img/icons/fgvnxnhj.json" state="hover-looking-around"
                  stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                </lord-icon>
              </a>
              <a class="p-2 px-3 pointer" @click="search()">
                <lord-icon class="nav-lord-icon" src="/img/icons/onakdvdu.json" state="hover-looking-around"
                  stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
                </lord-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed camera-mobile d-lg-none" v-if="!$route.fullPath.includes('cam')">
        <router-link class="color-black p-3" aria-label="خانه" to="/" v-if="!$User.isStaff">
          <lord-icon style="margin: 10px 0px;" class="nav-lord-icon" src="/img/icons/ywqonish.json" state="loop-smoke"
            stroke="bold" colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
          </lord-icon>
        </router-link>
        <router-link class="color-black p-3" aria-label="epay" to="/epay" v-if="$User.isStaff">
          <lord-icon style="margin: 10px 0px;" class="nav-lord-icon" src="/img/icons/uymmojcb.json" stroke="bold"
            colors="primary:#320a5c,secondary:#cb5eee" trigger="hover">
          </lord-icon>
        </router-link>
      </div>

      <button v-if="!$route.fullPath.includes('cam')" @click="goTotop" id="myBtn" class="btn btn-outline-success"
        aria-label="رفتن به بالای صفحه"><i class="fa fa-arrow-up gototop-icon"></i></button>
      <footer class="footer pb-md-0 pb-5 pt-5" v-if="!$route.fullPath.includes('cam')">
        <div class="container">
          <div class="row" dir="rtl">
            <div class="col-md-3 col-12 p-4 footer-text m-auto py-2 m-0">
              <img src="./assets/logo.png" class="footer-logo" alt="nuorashop | نوراشاپ">
              <p>نوراشاپ با تیم قوی در حوزه فروش و بازاریابی برای ساختن یک زیر ساخت جدید و ارائه بهترین خدمات اینترنتی
                طراحی
                شده است.</p>
            </div>
            <div class="col-md-3 col-6 p-4 footer-text br-solid m-auto py-2 m-0">
              <p><router-link to="/"><i class="fa fa-home" aria-hidden="true"></i> خانه</router-link></p>
              <p><router-link to="/category-list"><i class="fa fa-shopping-bag" aria-hidden="true"></i>
                  فروشگاه</router-link>
              </p>
              <p><router-link to="/brands"><i class="fa fa-tag" aria-hidden="true"></i> برند‌ها</router-link></p>
              <p><router-link to="/blogs"><i class="fa fa-blog" aria-hidden="true"></i> مطالب</router-link></p>
              <p><router-link to="/events"><i class="fa fa-gift" aria-hidden="true"></i> خرید کادو</router-link></p>
            </div>
            <div class="col-md-3 col-6 p-4 footer-text br-solid m-auto py-2 m-0">
              <p v-if="this.$route.query.mode != 'pwa'"><router-link to="/install-app"><i class="fa fa-download"
                    aria-hidden="true"></i> نصب برنامه</router-link></p>
              <p><router-link to="/contact"><i class="fa fa-phone" aria-hidden="true"></i> ارتباط‌با‌ما</router-link>
              </p>
              <p><router-link to="/about"><i class="fa fa-info-circle" aria-hidden="true"></i> درباره‌ما</router-link>
              </p>
              <p>
                <router-link to="/terms">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bank"
                    viewBox="0 0 16 16">
                    <path
                      d="m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.5.5 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm2 0v7h2.5V6zm3.5 0v7h1V6zm2 0v7H12V6zM13 6v7h1V6zm2-1V4H1v1zm-.39 9H1.39l-.25 1h13.72z" />
                  </svg>
                  قوانین سایت
                </router-link>
              </p>
              <p>
                <router-link to="/social">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-chat-right-heart-fill" viewBox="0 0 16 16">
                    <path
                      d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353zM8 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132" />
                  </svg>
                  شبکه‌های اجتماعی
                </router-link>
              </p>
            </div>
            <CertificateView class="col-md-3 col-12 p-4 justify-content-center" />
            <div class="col-12 p-4 m-auto text-center" dir="ltr">
              <hr>
              <span>© 2022 Nuora from </span>
              <a href="https://tmayt.ir">TMAYT</a>
            </div>
          </div>
        </div>
      </footer>
      <div class="offcanvas offcanvas-end cart-offcanvas" data-bs-scroll="true" tabindex="-1" id="cart"
        aria-labelledby="cart-header">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="cart-header">سبد خرید</h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="بستن"></button>
        </div>
        <div class="offcanvas-body" id="cart-body">
          <div v-if="Object.keys(cart).length === 0">
            <p class="color-gray font-size-18 text-center mt-4">
              <lord-icon src="/img/icons/fgvnxnhj.json" trigger="loop" delay="2000">
              </lord-icon>
            </p>
            <p class="color-gray text-center mt-2">سبد خرید شما خالی می‌باشد</p>
          </div>
          <div class="cart-item position-relative d-flex justify-content-between py-2" dir="rtl" v-for="item in cart"
            :key="item">
            <router-link
              :to="'/product/' + item.categorySlug + '/' + item.subCategorySlug + '/' + item.slug">
              <p class="cart-item-name mt-2">{{ strLimit(item.name, 30) }}</p>
              <p class="cart-item-price text-end" dir="ltr"><span>{{ item.count.toLocaleString('fa') }}</span> <i
                  class="fa-solid fa-x x-icon"></i> <span dir="rtl">{{ item.priceAfterOff.toLocaleString('fa')
                  }}
                  تومان </span></p>
            </router-link>
            <router-link
              :to="'/product/' + item.categorySlug + '/' + item.subCategorySlug + '/' + item.slug">
              <img class="cart-item-image" v-lazy="$MEDIA + item.image" :alt="item.name" />
            </router-link>
            <i @click="removeFromCart(item)"
              class="fa-solid fa-circle-xmark position-absolute remove-icon pointer"></i>
          </div>
          <div class="cart-footer" v-if="Object.keys(cart).length !== 0">
            <p class="text-end font-size-16 mx-2 my-4 color-gray"><span>مجموع کل :
              </span><span>{{ calculateTotalCart().toLocaleString('fa') }}</span> تومان</p>
            <router-link data-bs-dismiss="offcanvas" to="/checkout" class="btn btn-secondary club-btn">صورت
              حساب</router-link>
          </div>
        </div>
      </div>
      <div class="offcanvas offcanvas-end cart-offcanvas" data-bs-scroll="true" tabindex="-1" id="wish"
        aria-labelledby="wish-header">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="wish-header">لیست علاقه‌مندی‌ها</h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="بستن"></button>
        </div>
        <div class="offcanvas-body" id="wish-body">
          <div v-if="Object.keys(wish).length === 0">
            <p class="color-gray font-size-18 text-center mt-4">
              <lord-icon src="/img/icons/tacaigvj.json" trigger="loop" delay="2000">
              </lord-icon>
            </p>
            <p class="color-gray text-center mt-2">لیست علاقه‌مندی شما خالی می‌باشد</p>
          </div>
          <div class="cart-item d-flex justify-content-between" dir="rtl" v-for="item in wish" :key="item">
            <router-link :to="'/product/' + item.categorySlug + '/' + item.subCategorySlug + '/' + item.slug">
              <p class="cart-item-name mt-2">{{ strLimit(item.name, 30) }}</p>
              <p class="cart-item-price text-end"><span dir="rtl">{{ item.priceAfterOff.toLocaleString('fa') }} تومان
                </span>
              </p>
            </router-link>
            <router-link :to="'/product/' + item.categorySlug + '/' + item.subCategorySlug + '/' + item.slug">
              <img class="cart-item-image" v-lazy="$MEDIA + item.image" :alt="item.name" />
            </router-link>
            <i @click="removeFromWish(item)"
              class="fa-solid fa-circle-xmark position-absolute remove-icon pointer"></i>
          </div>
        </div>
      </div>
      <MsgModal />
    </div>
    <div class="epay" v-if="$route.fullPath.includes('epay')">
      <EpayMain />
    </div>
    <LoginModal />
  </div>
</template>

<script>
import LoginModal from '@/components/LoginModal.vue'
import MsgModal from '@/components/MsgModal.vue'
import CertificateView from '@/components/CertificateView.vue'
import BlogCard from '@/components/BlogCard.vue'
import EpayMain from './views/EpayMain.vue'

export default {
  name: 'App',
  components: {
    LoginModal,
    MsgModal,
    CertificateView,
    EpayMain,
    BlogCard
  },
  data () {
    return {
      cart: {},
      concepts: {},
      wish: {},
      deferredPrompt: null,
      showMega: false,
      showMegaBrands: false
    }
  },
  methods: {
    calculateTotalCart () {
      let x = Object.values(this.cart).reduce((total, item) => {
        return total + item.priceAfterOff * item.count
      }, 0)
      x += Object.values(this.concepts).reduce((total, item) => {
        return total + item.concept.price
      }, 0)
      return x
    },
    logout: function () {
      this.fire({
        title: 'از خروج  حساب کاربری خود مطمئنید؟',
        showCancelButton: true,
        confirmButtonText: 'بله',
        cancelButtonText: 'لغو',
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.isConfirmed) {
          const cart = localStorage.getItem('cart')
          const wish = localStorage.getItem('wish')
          localStorage.clear()
          localStorage.setItem('cart', cart)
          localStorage.setItem('wish', wish)
          const mutation = `
            mutation logout {
              logout {
                success
              }
            }
          `
          this.$fetchGraphQL(mutation).then(response => {
            location.reload()
          })
        }
      })
    },
    search: function () {
      this.fire({
        icon: 'onakdvdu',
        title: 'جستجو میان محصولات',
        text: '',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
          placeholder: 'جستجو بر اساس نام محصول'
        },
        imageInput: true,
        textImage: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="30" height="30">
          <!-- Square Box -->
          <rect x="10" y="10" width="80" height="80" fill="#007BFF" stroke="#0056b3" stroke-width="3" />
          <!-- Text -->
          <text x="50" y="60" text-anchor="middle" font-family="Arial, sans-serif" font-size="45" fill="#FFFFFF" font-weight="bold">
            AI
          </text>
        </svg>
        اگر نام محصول خود را نمی‌دانید می‌توانید بر اساس تصویر محصول مد نظر را جستجو کنید.
        `,
        showCancelButton: false,
        confirmButtonText: 'جستجو',
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.isConfirmed) {
          if (result.image) {
            const loading = document.getElementById('loading')
            loading.style.display = 'flex'
            const mutation = `
            mutation uploadFile($image: String!) {
              searchProductsByImage(image: $image) {
                status
                similarIds
              }
            }
            `
            const reader = new FileReader()
            reader.onload = () => {
              const base64 = reader.result
              this.$fetchGraphQL(mutation, { image: base64 }).then(response => {
                loading.style.display = 'none'
                if (response.data.searchProductsByImage.status === 'success') {
                  this.$router.push('/search?pklist=' + response.data.searchProductsByImage.similarIds + '&q=' + result.value)
                } else {
                  this.fire({
                    icon: 'error',
                    title: 'اشکالی به وجود آمده',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
              })
            }
            reader.onerror = (error) => {
              console.error('Error reading file:', error)
            }
            reader.readAsDataURL(result.image)
          } else {
            this.$router.push('/search?q=' + result.value)
          }
        }
      })
    },
    async dismiss () {
      this.deferredPrompt = null
    },
    async install () {
      this.deferredPrompt.prompt()
    },
    pageLoad: function () {
      this.activeFilters = this.parseExtra(this.$route.fullPath.replace('/blogs', ''))
      if (!this.$route.query.sort) {
        this.$route.query.sort = '-pk'
      }
    }
  },
  mounted () {
    this.pageLoad()
    if (!localStorage.getItem('cross-site')) {
      localStorage.setItem('cross-site', this.$route.query.cs || '')
    }

    this.emitter.on('updateCart', isOpen => {
      this.cart = JSON.parse(localStorage.getItem('cart')) || {}
    })
    this.cart = JSON.parse(localStorage.getItem('cart')) || {}

    this.emitter.on('setConcept', isOpen => {
      this.concepts = JSON.parse(localStorage.getItem('concept')) || {}
    })
    this.concepts = JSON.parse(localStorage.getItem('concept')) || {}

    this.emitter.on('updateWish', isOpen => { this.wish = JSON.parse(localStorage.getItem('wish')) || {} })
    this.wish = JSON.parse(localStorage.getItem('wish')) || {}

    const loading = document.getElementById('loading')
    if (this.$popup && localStorage.getItem('popup') !== this.$popup.id) {
      this.fire({
        title: this.$popup.title,
        text: this.$popup.text,
        confirmButtonText: 'متوجه شدم'
      })
      localStorage.setItem('popup', this.$popup.id)
    }
    setTimeout(function alertFunc () {
      window.onscroll = function () { myFunction() }
      let mybutton
      try {
        mybutton = document.getElementById('myBtn')
      } catch { }
      function myFunction () {
        try {
          if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            mybutton.style.display = 'block'
          } else {
            mybutton.style.display = 'none'
          }
        } catch { }
      }
    }, 3000)
    console.log('ɴᴜᴏʀᴀ ᴠɪᴘ ᴄᴀʀᴅ (10% Oғғ) : 2021072600100035')
    loading.style.display = 'none'
    const body = document.getElementsByTagName('body')[0]
    body.style.overflow = ''
  },
  created () {
    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault()
      this.deferredPrompt = e
    })
    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null
      console.log('appinstalled')
    })
  }
}
</script>
<style scoped>
.vr {
  display: inline-block;
  align-self: stretch;
  width: 0.5px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.vr2 {
  display: inline-block;
  align-self: stretch;
  width: 0.5px;
  height: 100rem;
  background-color: currentcolor;
  opacity: 0.25;
}

.blog-sidebar-image {
  height: 50px;
  width: auto;
  border-radius: 10%;
}

.accordion-button:focus {
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}
</style>
<style>
@media only screen and (max-width: 700px) {
  button.nav-link {
    font-size: 10pt;
  }

  p.brand-name {
    font-size: 10pt;
  }
}
</style>
